import React from 'react'
import { Redirect, Switch, Route, HashRouter, BrowserRouter } from 'react-router-dom'
import Accounts from './pages/accounts/accounts'
import DetailedStatement from './pages/accounts/detailed-statement'
import LoanStatement from './pages/accounts/loan-statement'
import LoansView from './pages/accounts/loans'
import DepositView from './pages/accounts/deposits'
import Statement from './pages/accounts/statements'
import AdditionalLinks from './pages/additional-options/additional-options'
import Calculator from './pages/additional-options/calculator'
import ExchangeRates from './pages/additional-options/exchange-rates'
import TC from './pages/additional-options/terms-conditions'
import Landing from './pages/auth/Landing/Landing'
import Login from './pages/auth/login'
import Verify from './pages/auth/verify'
import Dashboard from './pages/dashboard/dashboard'
import BiStatement from './pages/download-center/bi-statement'
import DownLoadCenter from './pages/download-center/download-center'
import MT103 from './pages/download-center/mt103'
import Receipts from './pages/download-center/receipts'
import SalaryStatus from './pages/transfers/download-center/salary-file-status-download'
import Payments from './pages/payments/payments'
import ContactUs from './pages/support-center/contact-us'
import FAQ from './pages/support-center/faq'
import Location from './pages/support-center/location'
import Suggestions from './pages/support-center/suggestions'
import SupportCenter from './pages/support-center/support-center'
import BeneficiaryOption from './pages/transfers/beneficiary-options'
import BeneficiaryDownloadOption from './pages/transfers/beneficiary-download-options'
import AddDomesticBeneficiary from './pages/transfers/beneficiary/add-domestic-beneficiary'
import AddInternalBeneficiary from './pages/transfers/beneficiary/add-intenal-beneficiary'
import AddInternationalBeneficiary from './pages/transfers/beneficiary/add-international-beneficiary'
import BeneficiaryTransfer from './pages/transfers/beneficiary/beneficiary-transfer'
import BeneficiaryView from './pages/transfers/beneficiary/beneficiary-view'
import InternalAccountTransfer from './pages/transfers/internal-transfer'
import OtherAccountTransfer from './pages/transfers/other-transfer'
import Transfers from './pages/transfers/transfers'
import AboutUs from './pages/support-center/AboutUs'
import LandingBranch from './pages/auth/Landing/Branch'
import LandingExchangeRates from './pages/auth/Landing/ExchangeRates'
import LandingCalculator from './pages/auth/Landing/Calculator'
import Requests from './pages/request/request'
import Cheque from './pages/request/cheque/cheque'
import ChequeBookRequest from './pages/request/cheque/cheque-book-request'
import StopChequePayment from './pages/request/cheque/stop-cheque'
import StandingInstruction from './pages/request/standing-instruction'
import CreateStandingInstruction from './pages/request/si-create'
import Profile from './pages/profile/profile'
import ChangePassword from './pages/changePassword/changePasswrd'
import Portfolio from './pages/portfolio/portfolio'
import ForgotPassword from './pages/auth/ForgotPassword/ForgotPassword'
import OwnAccountTransfer from './pages/transfers/own-account-transfer'
import InternationalAccountTransfer from './pages/transfers/international-transfer'
import Approvals from './pages/approvals/approvals'
import ApprovalPayments from './pages/approvals/payments'
import ApprovalSI from './pages/approvals/si'
import ApprovalChequeBook from './pages/approvals/chequeBook'
import ApprovalFT from './pages/approvals/ft'
import ApprovalSalaryUpload from './pages/approvals/salaryUpload'
import ApprovalBeneficiaries from './pages/approvals/beneficiary'
import ApprovalStopCheque from './pages/approvals/stopCheque'
import ApprovalDeposit from './pages/approvals/td'
import History from './pages/history/history'
import AddBiller from './pages/payments/biller-list/add-biller'
import BillerBeneList from './pages/payments/biller-list/biller-bene-list'
import InstantTransfer from './pages/quickPay/instantTransfer'
import AddAccountName from './pages/AccountName/AccountName'
import EditInternalBeneficiary from './pages/transfers/beneficiary/edit-internal-beneficiary'
import EditDomesticBeneficiary from './pages/transfers/beneficiary/edit-domestic-beneficiary'
import EditInternationalBeneficiary from './pages/transfers/beneficiary/edit-international-beneficiary'
import BulkTransfer from './pages/transfers/bulk-transfer'
import SalaryUpload from './pages/transfers/salary-upload'
import ResetPassword from './pages/auth/resetPassword'
import HistoryPayments from './pages/history/payments'
import HistoryStopCheque from './pages/history/stopCheque'
import HistoryBeneficiaries from './pages/history/beneficiary'
import HistorySI from './pages/history/si'
import HistoryChequeBook from './pages/history/chequeBook'
import HistoryFT from './pages/history/ft'
import HistorySalaryUpload from './pages/history/salaryUpload'
import HistoryDeposit from './pages/history/td'
import TransferMT103 from './pages/transfers/download-center/mt103'
import TransferReciept from './pages/transfers/download-center/receipts'
import SalaryStatusDownload from './pages/download-center/salary-file-status-download'
import TransferBi from './pages/transfers/download-center/bi-statement'
import CreateTermDeposits from './pages/deposits/create-term-deposits'
import SendToWallet from './pages/send-to-wallet/sendToWallet'
import Landing_ContactUs from './pages/auth/Landing/Contact-Us'
import CurrentMonthStatement from './pages/accounts/current-month-stmt'
import LastTwoMonthStatement from './pages/accounts/last-two-month-stmt'
import LastThreeMonthStatement from './pages/accounts/last-three-month-stmt'
import CustomDatesStatement from './pages/accounts/custom-dates-stmt'
import BillerServicesView from './pages/payments/billers-services-view'
import BillerProduct from './pages/payments/billers-service-form'
import CardLessCash from './pages/cardLess-cash/cardLess-cash'
import GenerateToken from './pages/cardLess-cash/generateToken'
import ApprovalCardLessCash from './pages/approvals/cardLessCash'
import HistoryCardLessCash from './pages/history/cardLessCash'
import TransferBillerProduct from './pages/transfers/billers-service-form'
import PayBills from './pages/payments/payBills'
import ChequeStatus from './pages/request/cheque/cheque-status'
import QuickPay from './pages/quickPay/quickPay'
import TransferBillerServicesView from './pages/transfers/billers-service-view'
import DebitCard from './pages/request/debit-card.jsx/debit-card'
import CardRequest from './pages/request/debit-card.jsx/card-request/card-request'
import ApprovalDebitCard from './pages/approvals/debitCard'
import HistoryDebitCard from './pages/history/debitCard'
import ViewScheduledTansfers from './pages/transfers/download-center/viewScheduled'
import ViewScheduledPayments from './pages/payments/viewScheduledPayments'
import AddRegionalBeneficiary from './pages/transfers/beneficiary/add-regional-beneficiary';
import RegionalTransfer from './pages/transfers/regional-transfer';
import EditRegionalBeneficiary from './pages/transfers/beneficiary/edit-regional-beneficiary';
import BlockDebitCard from './pages/request/debit-card.jsx/block-card/block-card';
import ApprovalBlockCard from './pages/approvals/blockCard';
import HistoryBlockCard from './pages/history/blockCard';
import SchoolPayBillerProduct from './pages/payments/school-pay-form'

export default function AppRouter() {
  return (
    <BrowserRouter>
      <HashRouter>
        <Switch>
          <Route exact path='/login'>
            <Login />
          </Route>
          <Route exact path='/landing'>
            <Landing />
          </Route>

          <Route exact path='/verify'>
            <Verify />
          </Route>
          <Route exact path='/resetPassword'>
            <ResetPassword />
          </Route>

          <Route exact path='/dashboard'>
            <Dashboard />
          </Route>

          <Route exact path='/profile'>
            <Profile />
          </Route>

          <Route exact path='/send-to-mobile'>
            <SendToWallet />
          </Route>

          <Route exact path='/add-accountName'>
            <AddAccountName />
          </Route>

          <Route exact path='/change-password'>
            <ChangePassword />
          </Route>

          <Route exact path='/transfers/download-center/mt103'>
            <TransferMT103 />
          </Route>
          <Route exact path='/transfers/viewScheduled'>
            <ViewScheduledTansfers />
          </Route>
          <Route exact path='/transfers/download-center/reciept'>
            <TransferReciept />
          </Route>

          <Route exact path='/transfers/download-center/salary-file-status-download'>
            <SalaryStatus />
          </Route>
          <Route exact path='/salary-file-status-download'>
            <SalaryStatusDownload />
          </Route>

          <Route exact path='/transfers/download-center/bi'>
            <TransferBi />
          </Route>

          <Route exact path='/forgot-password'>
            <ForgotPassword />
          </Route>
          <Route path='/deposits/create-term-deposits'>
            <CreateTermDeposits />
          </Route>

          <Route exact path='/accounts'>
            <Accounts />
          </Route>

          <Route exact path='/portfolio'>
            <Portfolio />
          </Route>

          <Route exact path='/loans-view'>
            <LoansView />
          </Route>

          <Route exact path='/deposit-view'>
            <DepositView />
          </Route>

          <Route exact path='/statement'>
            <Statement />
          </Route>

          {/* About Us */}
          <Route exact path='/about-us'>
            <AboutUs />
          </Route>

          <Route exact path='/loan-statement'>
            <LoanStatement />
          </Route>

          <Route exact path='/detailed-statement'>
            <DetailedStatement />
          </Route>

          <Route exact path='/transfers'>
            <Transfers />
          </Route>

          <Route exact path='/transfers/add-beneficiary'>
            <BeneficiaryOption />
          </Route>

          <Route exact path='/transfers/download-center'>
            <BeneficiaryDownloadOption />
          </Route>

          <Route exact path='/transfers/add-beneficiary/internal'>
            <AddInternalBeneficiary />
          </Route>
          <Route exact path='/transfers/add-beneficiary/domestic'>
            <AddDomesticBeneficiary />
          </Route>

          <Route exact path='/transfers/add-beneficiary/international'>
            <AddInternationalBeneficiary />
          </Route>

          <Route exact path='/transfers/edit-beneficiary/internal'>
            <EditInternalBeneficiary />
          </Route>

          <Route exact path='/transfers/edit-beneficiary/other'>
            <EditDomesticBeneficiary />
          </Route>

          <Route exact path='/transfers/edit-beneficiary/international'>
            <EditInternationalBeneficiary />
          </Route>

          <Route exact path='/transfers/beneficiary-view'>
            <BeneficiaryView />
          </Route>

          <Route exact path='/transfers/beneficiary-transfers'>
            <BeneficiaryTransfer />
          </Route>
          <Route exact path='/transfers/beneficiary-transfers/internal'>
            <InternalAccountTransfer />
          </Route>
          <Route exact path='/transfers/beneficiary-transfers/other'>
            <OtherAccountTransfer />
          </Route>

          <Route exact path='/transfers/beneficiary-transfers/own'>
            <OwnAccountTransfer />
          </Route>

          <Route exact path='/transfers/beneficiary-transfers/international'>
            <InternationalAccountTransfer />
          </Route>

          <Route exact path='/payments'>
            <Payments />
          </Route>

          <Route exact path='/download-center'>
            <DownLoadCenter />
          </Route>

          <Route exact path='/receipts'>
            <Receipts />
          </Route>

          <Route exact path='/biStatement'>
            <BiStatement />
          </Route>

          <Route exact path='/mt103'>
            <MT103 />
          </Route>

          <Route exact path='/support-center'>
            <SupportCenter />
          </Route>
          <Route exact path='/locateUs'>
            <Location />
          </Route>

          <Route exact path='/faq'>
            <FAQ />
          </Route>
          <Route exact path='/suggestion'>
            <Suggestions />
          </Route>
          <Route exact path='/contact-us'>
            <ContactUs />
          </Route>

          <Route exact path='/additional-links'>
            <AdditionalLinks />
          </Route>

          <Route exact path='/calculator'>
            <Calculator />
          </Route>

          <Route exact path='/exchange-rate'>
            <ExchangeRates />
          </Route>

          <Route exact path='/tc'>
            <TC />
          </Route>

          <Route exact path='/landing'>
            <Landing />
          </Route>

          <Route exact path='/landing/exchangeRates'>
            <LandingExchangeRates />
          </Route>

          <Route exact path='/landing/calculator'>
            <LandingCalculator />
          </Route>

          <Route exact path='/landing/locateUs'>
            <LandingBranch />
          </Route>

          <Route exact path='/requests'>
            <Requests />
          </Route>
          <Route exact path='/requests/cheque'>
            <Cheque />
          </Route>

          <Route exact path='/requests/cheque/cheque-book-request'>
            <ChequeBookRequest />
          </Route>

          <Route exact path='/requests/cheque/stop-cheque-payment'>
            <StopChequePayment />
          </Route>

          <Route exact path='/requests/standing-instruction'>
            <StandingInstruction />
          </Route>

          <Route exact path='/requests/standing-instruction/create'>
            <CreateStandingInstruction />
          </Route>

          <Route exact path='/accounts/standing-instruction'>
            <StandingInstruction />
          </Route>

          <Route exact path='/accounts/standing-instruction/create'>
            <CreateStandingInstruction />
          </Route>

          <Route exact path='/requests/debit-card'>
            <DebitCard />
          </Route>

          <Route exact path='/requests/debit-card/card-request'>
            <CardRequest />
          </Route>

          <Route exact path='/requests/debit-card/block-card'>
            <BlockDebitCard />
          </Route>

          <Route exact path='/approvals'>
            <Approvals />
          </Route>

          <Route exact path='/approvals/stopCheque'>
            <ApprovalStopCheque />
          </Route>
          <Route exact path='/approvals/si'>
            <ApprovalSI />
          </Route>
          <Route exact path='/approvals/payments'>
            <ApprovalPayments />
          </Route>
          <Route exact path='/approvals/chequeBook'>
            <ApprovalChequeBook />
          </Route>
          <Route exact path='/approvals/ft'>
            <ApprovalFT />
          </Route>
          <Route exact path='/approvals/salaryUpload'>
            <ApprovalSalaryUpload />
          </Route>
          <Route exact path='/approvals/beneficiaries'>
            <ApprovalBeneficiaries />
          </Route>
          <Route exact path='/approvals/td'>
            <ApprovalDeposit />
          </Route>

          <Route exact path='/approvals/cardLessCash'>
            <ApprovalCardLessCash />
          </Route>

          <Route exact path='/approvals/debitCard'>
             <ApprovalDebitCard />
          </Route>

          <Route exact path='/approvals/blockCard'>
             <ApprovalBlockCard />
          </Route>

          <Route exact path='/history'>
            <History />
          </Route>

          <Route exact path='/history/payments'>
            <HistoryPayments />
          </Route>

          <Route exact path='/history/beneficiaries'>
            <HistoryBeneficiaries />
          </Route>

          <Route exact path='/history/stopCheque'>
            <HistoryStopCheque />
          </Route>

          <Route exact path='/history/si'>
            <HistorySI />
          </Route>

          <Route exact path='/history/chequeBook'>
            <HistoryChequeBook />
          </Route>

          <Route exact path='/history/ft'>
            <HistoryFT />
          </Route>
          <Route exact path='/history/salaryUpload'>
            <HistorySalaryUpload />
          </Route>
          <Route exact path='/history/td'>
            <HistoryDeposit />
          </Route>

          <Route exact path='/history/cardLessCash'>
            <HistoryCardLessCash />
          </Route>

          <Route exact path='/history/debitCard'>
            <HistoryDebitCard />
          </Route>

          <Route exact path='/history/blockCard'>
            <HistoryBlockCard />
          </Route>
          
          <Route exact path='/payments/servicesView'>
            <BillerServicesView />
          </Route>

          <Route exact path='/payments/services/product'>
            <BillerProduct />
          </Route>

          <Route exact path='/payments/services/school/product'>
            <SchoolPayBillerProduct />
          </Route>

          <Route exact path='/payments/payBills'>
            <PayBills />
          </Route>

          <Route exact path='/payments/add-biller'>
            <AddBiller />
          </Route>

          <Route exact path='/payments/viewScheduled'>
            <ViewScheduledPayments />
          </Route>

          <Route exact path='/payments/biller-list'>
            <BillerBeneList />
          </Route>
          
          {/* Quick Pay */}

          <Route exact path='/transfers/quick-pay'>
            <QuickPay />
          </Route>
          <Route exact path='/transfers/quick-pay/instant-transfer'>
            <InstantTransfer />
          </Route>

          <Route exact path='/transfers/quick-pay/servicesView'>
            <TransferBillerServicesView />
          </Route>
          <Route exact path='/transfers/quick-pay/services/product'>
            <TransferBillerProduct />
          </Route> 

          
          <Route exact path='/accounts/quick-pay'>
            <QuickPay />
          </Route>
          <Route exact path='/accounts/quick-pay/instant-transfer'>
            <InstantTransfer />
          </Route>

          <Route exact path='/accounts/quick-pay/servicesView'>
            <TransferBillerServicesView />
          </Route>
          <Route exact path='/accounts/quick-pay/services/product'>
            <TransferBillerProduct />
          </Route> 

          <Route exact path='/transfers/bulkTransfer'>
            <BulkTransfer />
          </Route>
          <Route exact path='/transfers/salaryUpload'>
            <SalaryUpload />
          </Route>

          <Route exact path='/landing/contactUs'>
            <Landing_ContactUs />
          </Route>

          <Route exact path='/currentMonth'>
            <CurrentMonthStatement />
          </Route>

          <Route exact path='/lastTwoMonth'>
            <LastTwoMonthStatement />
          </Route>

          <Route exact path='/lastThreeMonth'>
            <LastThreeMonthStatement />
          </Route>

          <Route exact path='/customDates'>
            <CustomDatesStatement />
          </Route>

          <Route exact path='/cardLessCash'>
            <CardLessCash />
          </Route>

          <Route exact path='/cardLessCash/generateToken'>
            <GenerateToken />
          </Route>

          <Route exact path='/requests/cheque/cheque-status'>
            <ChequeStatus />
          </Route>

          <Route exact path='/transfers/add-beneficiary/regional'>
            <AddRegionalBeneficiary />
          </Route>

          <Route exact path='/transfers/beneficiary-transfers/region'>
            <RegionalTransfer />
          </Route>

          <Route exact path='/transfers/edit-beneficiary/regional'>
            <EditRegionalBeneficiary />
          </Route>

          {/* <Route exact path='/currentMonth'>
            <CurrentMonthStatement />
          </Route>
          <Route exact path='/lastTwoMonth'>
            <LastTwoMonthStatement />
          </Route>
          <Route exact path='/lastThreeMonth'>
            <LastThreeMonthStatement />
          </Route>
          <Route exact path='/customDates'>
            <CustomDatesStatement />
          </Route> */}

          <Redirect exact from='/' to='/landing' />
        </Switch>
      </HashRouter>
    </BrowserRouter>
  )
}
